import React, { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/fp/isEmpty';
import apiRoutes from '../../../../config/api/routes';
import { useFetch } from '../../../shared/hooks';
import { Filter as AppFilter } from '../../../shared/components';
import { IGroup } from '../../../../config/api/models/Group';
import { styled } from '@material-ui/core';

const Filter = styled(AppFilter)({
  flex: 1,
});

type Props = {
  trajectoryId: string;
  bookId: string;
  value: string;
  onChange: (groupId: string) => void;
};
const GroupSelect: FC<Props> = ({ trajectoryId, bookId, value, onChange }) => {
  const { t } = useTranslation();
  const [groupVisibilitiesResponse, getGroupVisibilities] = useFetch<IGroup[]>(
    apiRoutes.groupVisibilities(bookId, trajectoryId)
  );

  useEffect(() => {
    getGroupVisibilities();
  }, [getGroupVisibilities]);

  const groupOptions = useMemo(() => {
    if (!groupVisibilitiesResponse.success) return [];
    return groupVisibilitiesResponse.data.map((group: IGroup) => ({
      id: group.id,
      label: group.name,
    }));
  }, [groupVisibilitiesResponse]);

  const isError =
    groupVisibilitiesResponse.error || (groupVisibilitiesResponse.success && isEmpty(groupOptions));

  return (
    <Filter
      id="group-filter"
      label={t('trajectory.sidebar.assignments.form.group')}
      value={value}
      onChange={onChange}
      options={groupOptions}
      required
      error={isError}
      helperText={isError ? t('assignments.form.errors.noGroups') : ''}
    />
  );
};

export default GroupSelect;
